import styled from 'styled-components'
import colors from '../../theming/variables/colors'
import MaterialUiButton from '@material-ui/core/Button'
import { darken, rgba } from 'polished'

export const themes = {
  default: {
    backgroundColor: colors.gray3,
    color: colors.black1
  },
  primary: {
    backgroundColor: colors.orange1,
    color: colors.white1
  }
}

export const Button = styled(MaterialUiButton)`
  background-color: ${(props) => props.theme.backgroundColor};
  border: 0;
  border-radius: 0.4rem;
  color: ${(props) => props.theme.color};
  cursor: pointer;
  font-family: inherit;
  font-size: inherit;
  font-weight: 400;
  letter-spacing: normal;
  line-height: inherit;
  margin: 0;
  padding: 0.8rem 1.6rem;
  text-transform: none;
  transition: background-color 0.25s;

  &:focus {
    outline: 0;
  }

  &:hover {
    background-color: ${(props) => darken(0.1, props.theme.backgroundColor)};
    transition: background-color 0.25s;
  }

  .MuiButton-startIcon {
    margin 0 0.5rem 0 0;

    *:first-child {
      font-size: inherit;
    }
  }

  &.Mui-disabled {
    background-color: ${(props) => rgba(props.theme.backgroundColor, 0.7)};
    color: ${(props) => rgba(props.theme.color, 0.7)};
  }
`
